import React from "react";
import { TransportOption } from "../../../models/financing-request/transport-option/TransportOption";
import AuthorizedCarrierTransportOption from "../../../models/financing-request/transport-option/AuthorizedCarrierTransportOption";
import { Grid, InputAdornment } from "@material-ui/core";
import TrTextField from "../../shared/controls/TrTextField";
import {
  nameof,
  getTooltipForDecimalInput,
  getCurrencyDisplayName
} from "../../../utilities/utilities";
import ValidationResult from "../../../hooks/change-tracker/ValidationResult";
import TrackerName from "../../../models/financing-request/student-data/FinancingRequestStudentDataTrackerName";
import FinancingRequestStudentData from "../../../models/financing-request/student-data/FinancingRequestStudentData";
import TrSelect from "../../shared/controls/TrSelect";
import { AuthorizedCarrier } from "../../../models/financing-request/AuthorizedCarrier";
import TrSelectData from "../../../models/shared/TrSelectData";
import Currency from "../../../models/shared/Currency";

interface Props {
  index: number;
  authorizedCarriers: AuthorizedCarrier[];
  transportOption: TransportOption;
  validationResult: ValidationResult;
  currency: Currency;
  onSelectChange: (e: any) => void;
}

export default function AuthorizedCarrierTransportItem({
  index,
  authorizedCarriers,
  transportOption,
  currency,
  onSelectChange,
  validationResult
}: Props) {
  let authorizedCarrierTransportOption = transportOption as AuthorizedCarrierTransportOption;

  function getSelected() {
    return authorizedCarriers.find(
      ac => ac.id == authorizedCarrierTransportOption.authorizedCarrierId
    );
  }

  return (
    <>
      <Grid item lg={3} md={6} sm={12} xs={12}>
        <TrSelect
          required
          name={nameof<typeof authorizedCarrierTransportOption>(
            "authorizedCarrierId"
          )}
          id="authorizedCarrierNameSelect"
          className="selectFormControl"
          label="Naziv prijevoznika"
          value={authorizedCarrierTransportOption.authorizedCarrierId}
          onChange={onSelectChange}
          selectData={
            {
              valueProp: "id",
              textProp: "name",
              data: authorizedCarriers
            } as TrSelectData<AuthorizedCarrier>
          }
          error={
            !validationResult.isArrayPropertyWithParrentValid(
              TrackerName.StudentsData,
              index.toString(),
              nameof<FinancingRequestStudentData>("transportOption"),
              nameof<AuthorizedCarrierTransportOption>("authorizedCarrierId")
            )
          }
        />
      </Grid>
      {authorizedCarrierTransportOption.authorizedCarrierId && getSelected() ? (
        <>
          <Grid item lg={3} md={6} sm={12} xs={12}>
            <TrTextField
              disabled
              label="Broj kilometara"
              value={getSelected()!.dailyMileage || ""}
              className="textField"
              InputProps={{
                endAdornment: <InputAdornment position="end">Km</InputAdornment>
              }}
            />
          </Grid>
          <Grid item lg={3} md={6} sm={12} xs={12}>
            <TrTextField
              disabled
              label="Cijena po danu"
              value={getSelected()!.dailyPrice || ""}
              className="textField"
              InputProps={{
                endAdornment: <InputAdornment position="end">{getCurrencyDisplayName(currency)}</InputAdornment>
              }}
            />
          </Grid>
        </>
      ) : (
        <></>
      )}
    </>
  );
}
